import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';

export default function Header({ onMenuClick, showMenuButton = false }) {
  const auth = useAuth();
  const { getTenant, clearTenant } = useTenant();
  const navigate = useNavigate();

  // Load tenant details
  const tenant = getTenant();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    auth.logout();
  };

  const handleSwitchTenant = () => {
    handleMenuClose();
    clearTenant();
    navigate('/select-tenant', { replace: true });
  };

  return (
    <AppBar position="static" elevation={0}>
      <Toolbar>
        {/* Mobile menu button */}
        {showMenuButton && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuClick}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography
          variant="h6"
          component={NavLink}
          to="/"
          sx={{
            textDecoration: 'none',
            color: 'inherit',
            fontWeight: 'bold',
            fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
          }}
        >
          {tenant && tenant.name ? tenant.name : "Shop Assist Pro"}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        {/* Account Menu Button */}
        <IconButton
          color="inherit"
          onClick={handleMenuOpen}
          sx={{ display: { xs: 'flex', sm: 'none' } }}
        >
          <AccountCircleIcon />
        </IconButton>
        <Button
          color="inherit"
          onClick={handleMenuOpen}
          startIcon={<AccountCircleIcon />}
          sx={{ textTransform: 'none', display: { xs: 'none', sm: 'flex' } }}
        >
          Account
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleSwitchTenant}>Switch Tenant</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
